import { getData, postData, putData } from "adminApi/apiClient";


export const createRoomBooking = async ({ data }) => {
  try {
    const result = await postData(`/room-booking/`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(
      "Create Room Checkin API error:",
      error.status === 400 ? error.error : error.message,
    );
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.errors : error.message,
        status: error.status,
      },
    };
  }
};

export const updateRoomBooking = async ({ id, data }) => {
  try {
    const result = await putData(`/room-booking/${id}`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error(
      "Upadte Room Checkin API error:",
      error.error || error.message,
    );
    return {
      data: {
        success: false,
        error: error.data.errors || error.message,
        status: error.status,
      },
    };
  }
};

export const viewCheckinWithId = async (id) => {
  try {
    const result = await getData(`/room-booking/view-ckeckin/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(`Get View Booking API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const getBookingById = async (id) => {
  try {
    const result = await getData(`/room-booking/${id}`);
    console.log("getBookingById result:", result);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(`Get Room Checkin data API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const getBalanceById = async (id) => {
  try {
    const result = await getData(`/room-booking/customer-ledger/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(`Get Room Checkin data API error:`, error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

export const GetAllBookings = async (
  { page = 1, limit = 10, search = "", ...filters },
  signal = null,
) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search,
    });

    // Append any extra filter params (booking_status_code, from_date, to_date, etc.)
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        queryParams.append(key, String(value));
      }
    });

    const result = await getData(
      `/room-booking/?${queryParams}`,
      {},
      {},
      signal,
    );
    return { success: true, ...result };
  } catch (error) {
    console.error(`Get Room Booking List with pagination API error:`, error);
    return { success: false, ...error };
  }
};

export const getAllRoomTypes = async () => {
  try {
    const result = await getData(`/room-booking/room-types`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(
      "Room API error:",
      error.status === 400 ? error.error : error.message,
    );
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};

export const getRoomNumbers = async (id, bodyData) => {
  try {
    const result = await postData(
      `/room-booking/room-list/${id}`,
      bodyData,
    );
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error(
      "Room API error:",
      error.status === 400 ? error.error : error.message,
    );

    return {
      success: false,
      error: error.status === 400 ? error.error : error.message,
      status: error.status || 500,
    };
  }
};

export const getComplementry = async (id) => {
  try {
    const result = await getData(`/room-booking/complementry/${id}`);
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error(
      "Room API error:",
      error.status === 400 ? error.error : error.message,
    );
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};
export const getCombinedRoomInfo = async (id, bodyData) => {
  try {
    const roomdata = await postData(`/room-booking/room-list/${id}`,
      bodyData,
    );

    const data = roomdata?.data || {};
    console.log("Combined Room API result:", data);

    return {
  success: true,
  rooms: data?.rooms || [],
  offer: data?.offer || null,        // full object
  offerValue: data?.offer?.offer || 0, // numeric value
  complementary: data?.complementary || [],
  room_type_info: data?.room_type_info || {}, // include room type details if needed
};
  } catch (error) {
    console.error(
      "Combined Room API error:",
      error.status === 400 ? error.error : error.message,
    );
    return {
      success: false,
      error: error.status === 400 ? error.error : error.message,
      status: error.status || 500,
    };
  }
};

export const getExistingCustomer = async (contactNumber) => {
  try {
    const result = await getData(
      `/room-booking/customers/${contactNumber}`,
    );
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error(
      "Room API error:",
      error.status === 400 ? error.error : error.message,
    );
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};

export const getAllPaymentMethods = async () => {
  try {
    const result = await getData(`/room-booking/payment-methods`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(
      "Room API error:",
      error.status === 400 ? error.error : error.message,
    );
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};

export const getChargePercent = async () => {
  try {
    const result = await getData(`/room-booking/tax-charges`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error(
      "Tax API error:",
      error.status === 400 ? error.error : error.message,
    );
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};



export const viewBookingWithId = async (id) => {
    try {
        const result = await getData(`/room-booking/view-booking/${id}`);
        return {
            data: {
                success: true,
                ...result,
            },
        };
    } catch (error) {
        console.error(`Get View Booking API error:`, error);
        return {
            data: {
                success: false,
                error: error.message,
            },
        };
    }
}

export const getBookingRef =()=>{}
export const getRoomBookingTypes =()=>{}